import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import { BodyM, HeadingSBold } from 'components/Typography/Typography';
import React, { createRef } from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/billingPaymentTrack/excelPreviewStyle';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import { VerticalAlignBottom } from '@material-ui/icons';
import { OfflinePayment } from 'utils/api/models/billingPaymentTrack/offlinePayment';
import { BillingPaymentTrackService } from 'services/billingPaymentTrack/billingPaymentTrack';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IUploadedFilesDialog {
	isOpen: boolean;
	hideDialog: () => void;
	offlinePayment: OfflinePayment | undefined;
}

const UploadedFilesDialog = ({ isOpen, hideDialog, offlinePayment }: IUploadedFilesDialog) => {
	const classes = useStyles();

	const excelFile = offlinePayment?.attachments.find((attachment) => attachment.attachmentType === 'EXCEL');
	const proofFiles = offlinePayment?.attachments.filter((attachment) => attachment.attachmentType === 'PROOF');

	return (
		<CustomDialog
			header={translate('billing.payment.track.uploaded.files.heading')}
			line={false}
			isOpen={isOpen}
			hideDialog={hideDialog}
			loading={false}
			width={668}
			dialogBody={
				<div className={classes.tableWrapper}>
					<div className={classes.uploadedFilesHeadingRow}>
						<HeadingSBold>{translate('billing.payment.track.uploaded.files.excel')}</HeadingSBold>
						<HeadingSBold>{'1 ' + translate('billing.payment.track.uploaded.files.file')}</HeadingSBold>
					</div>
					<FileRow attachmentId={excelFile?.id} fileName={excelFile?.name || ''} />
					<div className={classes.uploadedFilesHeadingRow}>
						<HeadingSBold>{translate('billing.payment.track.uploaded.files.proof')}</HeadingSBold>
						<HeadingSBold>
							{proofFiles?.length + ' ' + translate('billing.payment.track.uploaded.files.files')}
						</HeadingSBold>
					</div>
					{(proofFiles || []).map((proofFile) => {
						return <FileRow attachmentId={proofFile?.id} fileName={proofFile.name} key={proofFile.id} />;
					})}
				</div>
			}
		/>
	);
};

interface IFileRow {
	fileName: string;
	attachmentId: number | undefined;
}

const FileRow = ({ fileName, attachmentId }: IFileRow) => {
	const link = createRef<HTMLAnchorElement>();
	const classes = useStyles();

	const downloadFile = () => {
		if (!link.current?.href && typeof attachmentId === 'number') {
			BillingPaymentTrackService.downloadAttachment(attachmentId).subscribe((resp) => {
				const href = window.URL.createObjectURL(resp.response);

				if (link.current) {
					link.current.download = fileName;
					link.current.href = href;

					link.current.click();
				}
			});
		}
	};

	return (
		<div className={classes.uploadedFilesRow}>
			<InsertDriveFileOutlinedIcon className={classes.fileIcon} />
			<BodyM>{fileName}</BodyM>
			<a ref={link} onClick={downloadFile}>
				<div className={classes.downloadLink}>
					<VerticalAlignBottom />
				</div>
			</a>
		</div>
	);
};

export default UploadedFilesDialog;
